<hpf-category-form
        *ngIf="category"
        [category]="category"
        (create)="onCreate($event)"
    ></hpf-category-form>
<div *ngIf="!category" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>